module.exports = (state, payload) => {
  const box = payload.action || payload.payload
  
  const boxId = box?.id
  if (boxId !== undefined) {
    // Instead of an object, we could use a Map, so we make sure we only add each box once.
    const existedBefore = state.boxes[boxId]
    box.nickName = box.nickName = box.boxname
    box.msgunopen = box.msgunopen || 0
    state.boxes[boxId] = box
    if (!existedBefore) { state.boxesCount = state.boxesCount + 1 }
    return state
  } else {
    throw new Error('Cannot create box with id: undefined')
  }
}
